import { defineComponent as z, useSlots as G, computed as t, openBlock as s, createBlock as r, unref as m, withCtx as H, createElementVNode as y, normalizeClass as o, createElementBlock as c, createCommentVNode as n, renderSlot as C, mergeProps as w, resolveDynamicComponent as M, toRaw as U } from "vue";
import { RevIllustration as q } from "@ds/components/Illustration";
import { RevRadioBase as F } from "@ds/components/RadioBase";
import { RevTag as J } from "@ds/components/Tag";
import { usePropsValidation as K } from "../../composables/usePropsValidation.js";
import { useSelectionCardBorder as Q } from "../../composables/useSelectionCardBorder.js";
import { isString as v } from "../../utils/isString.js";
import { isValidNumber as N } from "../../utils/isValidNumber.js";
import { tw as a } from "../../utils/tailwind.js";
import { RADIO_CLASS_NAMES as f, CHANGE_EVENT as X } from "./Radio.constant.js";
const Y = ["for"], oe = /* @__PURE__ */ z({
  name: "RevRadio",
  __name: "Radio",
  props: {
    modelValue: { type: [Boolean, String] },
    disabled: { type: Boolean, default: !1 },
    displayDescriptionOnlyWhenChecked: { type: Boolean, default: !1 },
    id: {},
    image: { default: () => {
    } },
    tagProps: { default: () => {
    } },
    imageProps: { default: () => {
    } },
    value: {},
    variant: { default: "default" }
  },
  emits: ["change", "update:modelValue"],
  setup(e, { emit: V }) {
    const h = G(), g = V, B = t(() => h.label ? e.variant !== "imageOnly" : !1), R = t(() => h.description ? e.variant === "full" : !1), x = t(() => !!e.tagProps && e.variant === "full"), d = t(() => e.variant !== "default"), u = t({
      get() {
        return typeof e.modelValue == "string" ? e.modelValue === e.value : e.modelValue;
      },
      set(l) {
        l !== e.modelValue && g("update:modelValue", l);
      }
    });
    function O(l) {
      g(X, l);
    }
    const i = t(() => {
      const l = e.imageProps || {};
      return {
        ...l,
        height: N(l.height) ? l.height : 24,
        width: N(l.width) ? l.width : 24,
        src: v(e.image) ? e.image : void 0,
        alt: v(l.alt) ? l.alt : void 0
      };
    }), P = t(() => e.variant !== "default" && v(i.value.alt));
    K({
      "Radio: image must have an alt text when using the ImageOnly variant.": () => e.variant === "imageOnly" && !i.value.alt
    });
    function b(l) {
      return v(l);
    }
    const S = t(() => typeof e.image == "object"), { overlayClassNames: A } = Q(
      () => !!u.value,
      () => e.disabled
    ), D = t(() => [
      a`text-static-default-low body-2 ml-32 pt-8`,
      e.displayDescriptionOnlyWhenChecked && !u.value && a`hidden`,
      e.disabled && a`text-static-default-low-disabled`,
      f
    ]), E = t(() => [
      f,
      a`peer body-1 block`,
      d.value && a`rounded-sm relative p-16 peer-focus-visible:outline-default-hi`,
      e.variant === "full" && a`min-h-56`,
      !e.disabled && d.value && a`bg-static-default-low hover:bg-static-default-low-hover`,
      !e.disabled && a`text-action-default-hi cursor-pointer`,
      e.disabled && d.value && a`bg-static-default-low-disabled`,
      e.disabled && a`text-action-default-hi-disabled cursor-not-allowed`
    ]), I = t(() => [
      e.variant === "default" && a`left-0 top-2 peer-focus-visible:outline-default-hi`,
      e.variant === "full" && a`left-16 top-18`,
      e.variant === "imageOnly" && a`left-16 top-1/2 -mt-10`
    ]), T = t(() => [
      e.variant === "default" && a`left-6 top-8`,
      e.variant === "full" && a`left-22 top-24`,
      e.variant === "imageOnly" && a`left-22 top-1/2 -mt-4`
    ]), $ = a`ml-32 flex`, j = a`flex-1 ${f}`, L = t(() => [
      a`flex max-h-24 items-center`,
      e.variant === "full" && a`ml-16`,
      e.disabled && a`opacity-50`
    ]);
    return (l, k) => (s(), r(m(F), {
      id: e.id,
      "checkmark-class-names": I.value,
      "checkmark-tick-class-names": T.value,
      disabled: e.disabled,
      label: "",
      "model-value": u.value,
      value: e.value,
      onChange: O,
      "onUpdate:modelValue": k[0] || (k[0] = (W) => u.value = W)
    }, {
      default: H(() => [
        y("label", {
          class: o(E.value),
          for: e.id
        }, [
          d.value ? (s(), c("div", {
            key: 0,
            "aria-hidden": "true",
            class: o(m(A))
          }, null, 2)) : n("", !0),
          y("div", {
            class: o($)
          }, [
            B.value ? (s(), c("div", {
              key: 0,
              class: o(j)
            }, [
              C(l.$slots, "label")
            ])) : n("", !0),
            P.value ? (s(), c("div", {
              key: 1,
              class: o(L.value)
            }, [
              b(i.value.src) && b(i.value.alt) ? (s(), r(m(q), w({ key: 0 }, i.value, {
                alt: i.value.alt,
                src: i.value.src
              }), null, 16, ["alt", "src"])) : n("", !0),
              S.value ? (s(), r(M(U(e.image)), {
                key: 1,
                "aria-label": i.value.alt,
                role: "img"
              }, null, 8, ["aria-label"])) : n("", !0)
            ], 2)) : n("", !0)
          ]),
          R.value ? (s(), c("div", {
            key: 1,
            class: o(D.value)
          }, [
            C(l.$slots, "description")
          ], 2)) : n("", !0),
          x.value ? (s(), r(m(J), w({ key: 2 }, e.tagProps, { class: "absolute -top-10 right-16" }), null, 16)) : n("", !0)
        ], 10, Y)
      ]),
      _: 3
    }, 8, ["id", "checkmark-class-names", "checkmark-tick-class-names", "disabled", "model-value", "value"]));
  }
});
export {
  oe as default
};
